import { render } from "./EventSuccess.vue?vue&type=template&id=ae556798"
import script from "./EventSuccess.vue?vue&type=script&lang=js"
export * from "./EventSuccess.vue?vue&type=script&lang=js"

import exportComponent from "/__w/system/system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__